import React, { useEffect, useState } from "react";
import '../../../CSS/Materiales.css'
import {BsPlus,BsFiletypePdf} from "react-icons/bs";
import {getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import moment from "moment-timezone";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import { calibriBold,calibriRegular } from "../../../Fonts/font";
import { Button, CloseButton, Modal } from 'react-bootstrap';
import watermark from "../../../Img/watermark.png"
import { FaArrowLeftLong } from "react-icons/fa6";
import { getApi, postApi } from "../../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningToast } from "../../../Utils/AlertMessage";
import { PropagateLoader } from "react-spinners";
import Loading from '../../../Utils/Loading';

function GastosManoObra(){
    const obraId = parseInt(sessionStorage.getItem("obra"));
    const navigate = useNavigate();
    const day = moment().isoWeekday();
    const [gastos, setGastos] = useState([]);
    const [tablaGastos, setTablaGastos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [totalMano, setTotalMano] = useState(0);
    const [obra,setObra] = useState('');
    const [cliente,setCliente] = useState('');
    const [direccion,setDireccion] = useState('');
    const [fechaSelect, setFecha] = useState();
    const [typePdf, setTypePdf] = useState('');
    const [isLoading,setIsLoading]=useState(false);

    var registros = []
    var inicio='';
    var fin='';
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;

    //MODAL PDF
    const [showPdf, setShowPdf] = useState(false);
    const handleClosePdf = () => {
        setShowPdf(false);
        setFecha('');
        setTypePdf('');
    }
    const handleShowPdf = () =>{
        setShowPdf(true);
    }  

    useEffect(() => {
        const getGastosIni = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,26);
            if(permiso){
                const endpoint = 'gastos-mano-obra-ini/'+obraId;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setGastos(res.data[0].gastos);
                        setTablaGastos(res.data[0].gastos);
                        setTotalMano(res.data[0].total);
                        setObra(res.data[0].obra);
                        setDireccion(res.data[0].direccion);
                        setCliente(res.data[0].cliente);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getGastosIni();
    },[idUsuario,navigate,obraId]);

    const getGastosRegistrados = async () => {
        const endpoint = 'gastos-mano-obra-ini/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setGastos(res.data[0].gastos);
                setTablaGastos(res.data[0].gastos);
                setTotalMano(res.data[0].total);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2);
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const manoTotal = formato(totalMano);

    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/');
    }

    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaGastos.filter((elemento)=> {
            if(elemento.nombreEmp.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda;
        });
        setGastos(resBusqueda);
    }

    //Registrar pagos
    const [gastosData, setGastosData] = useState([]);
    const [lista, setLista] = useState([]);
    const [costs, setCosts] = useState([]);
    const [fechaGMO,setFechaGMO] = useState('')
    const [showGasMO, setShowGasMO] = useState(false);
    const handleCloseGMO = () => {
        setShowGasMO(false);
        setLista([]);
        setGastosData([]);
    }
    const handleShowGMO = async () =>{
        await getGastos();
        setShowGasMO(true);
    }
    const getGastos = async () =>{
        const obraId = parseInt(sessionStorage.getItem("obra"));
        const endpoint = 'gastos-mano-obra/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                console.log(res.data)
                setGastosData(res.data);
                setCosts(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const cancelar = async () => {
        if(lista.length === 0 ){
            handleCloseGMO();
        }else{
            warningToast('¿SEGURO QUE QUIERES SALIR?','UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS',true)
            .then((result) => {
                if (result.isConfirmed) {
                    handleCloseGMO();
                }
            })   
        } 
    }
    const confirmPay = async (id,cod,nom,apeP,apeM,extras,puesto) =>{
        if(extras === 0){
            if(document.getElementById(`cb${id}`).checked){
                const filtrar = costs.filter(emp => emp.idEmpleado === id);
                const pago = {idL: id,codL:cod, nomL:nom, appL:apeP, apmL:apeM, pueL:puesto, diasL: filtrar[0].dias, 
                    preL: filtrar[0].precio, extL:0, canExt:0, totL: filtrar[0].total
                }
                setLista([...lista, pago])
            }else{
                const eliminar = lista.filter((item) => item.idL !== id) ;
                setLista(eliminar)
            }
        }else{
            if(document.getElementById(`cb${id}`).checked){
                var cantExtra = parseFloat(document.getElementById(`ex${id}`).value)
                if(Number.isNaN(cantExtra) ){
                    warningToast('¡ERROR!','POR FAVOR INGRESE UNA CANTIDAD EXTRA DEL EMPLEADO: '+(nom).toUpperCase()+'. SINO COLOQUE UN CERO');
                    var inext = document.getElementById(`ex${id}`)
                    inext.disabled = true
                }else{
                    const filtrar = costs.filter(emp => emp.idEmpleado === id);
                    var cantTotal = filtrar[0].total
                    var suma = Math.round(cantExtra + cantTotal)
                    const pago = {idL: id,codL:cod, nomL:nom, appL:apeP, apmL:apeM, pueL:puesto, diasL: filtrar[0].dias, 
                        preL: filtrar[0].precio, extL:extras, canExt: cantExtra, totL:suma
                    }
                    setLista([...lista, pago])
                    var inext2 = document.getElementById(`ex${id}`)
                    inext2.disabled = true
                    //var total = await document.getElementById(`t${id}`)
                    //total.value = await suma
                }
            }else{
                const eliminar = lista.filter((item) => item.idL !== id) ;
                setLista(eliminar)
                var inext3 = document.getElementById(`ex${id}`)
                inext3.disabled = false
            }
        }
    }
    const faltaConfirmar = async () =>{
        warningToast('¡ERROR!','FALTAN EMPLEADOS POR CONFIRMAR');
    }
    const verificarPagos = () => {
        setShowGasMO(false);
        handleShowCP();
    }
    //Gastos atrasados
    const getGastosAtrasados = async (fechaIngresada) =>{
        const endpoint = 'gastos-mano-obra/'+obraId+'/'+fechaIngresada;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setGastosData(res.data);
                setCosts(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        for (var i = 0; i < gastos.length; i++) { //desmarcar los checkbox
            document.getElementById(`cb${gastos[i].idEmpleado}`).checked = false;
            if(gastos[i].extras===""){
                document.getElementById(`ex${gastos[i].idEmpleado}`).value =0
                var inext = document.getElementById(`ex${gastos[i].idEmpleado}`)
                inext.disabled = false
            }
        }
        lista.length = 0 //limpiar lista
    }
    //Confirmar pagos
    const [isSaving, setSaving] = useState(false);
    const [showCP, setShowCP] = useState(false);
    const handleCloseCP = () => {
        setShowCP(false);
        setShowGasMO(true);
    }
    const handleShowCP = async () =>{setShowCP(true);}
    const pagoAgregado = () => {
        setShowCP(false);
        setLista([]);
    }

    const guardarPagos = async () => {
        setSaving(true);
        var semana='';
        var fechaFormat = '';
        if (fechaGMO===''){
            var getdatetime = new Date();
            semana = moment(getdatetime,"DD-MM-YYYY").isoWeek()
            fechaFormat  = moment(getdatetime).format("YYYY-MM-DD")
        }else{
            semana = moment(fechaGMO,"YYYY-MM-DD").isoWeek()
            fechaFormat  = moment(fechaGMO).format("YYYY-MM-DD")
        }
        const listPagos = JSON.stringify(lista);
        const endpoint = 'gastos-mano-obra/';
        const data = {lista:listPagos,idObra:obraId,semana:semana,fechaFormat:fechaFormat};
        const res = await postApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="SE GUARDÓ EL REGISTRO CORRECTAMENTE"){
                pagoAgregado();
                getGastosRegistrados();
                successToast("AGREGADO");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        setSaving(false);
    }

    //MODAL DESCARGANDO
    const [showDescargar, setShowDescargar] = useState(false);
    const handleCloseDescarg = () => {
        setShowDescargar(false);
    }
    const handleShowDescarg = () =>{
        setShowDescargar(true);
    }

    /* PDF INICIO */
    const tipoPdf = e => {
        setTypePdf(e.target.value);
    }

    const getRegistros = async (fechaIngresada) =>{
        if(typePdf===''){
            warningToast('DEBE SELECCIONAR UNA OPCIÓN');
        }else{
            handleShowDescarg();
            if(typePdf==="semana"){
                if(fechaIngresada===undefined || fechaIngresada===''){
                    warningToast('DEBE INGRESAR UNA FECHA');
                }else{
                handleClosePdf();
                const endpoint = 'gastos-pdf/'+obraId+'/'+fechaIngresada;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        registros=res.data[0].lista
                        inicio=res.data[0].inicio
                        fin=res.data[0].fin
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
                if(registros.length===0){
                    warningToast('NO EXISTEN REGISTROS DE LA FECHA SELECCIONADA');
                }else{
                    descargar(registros,inicio,fin);
                }
                }
            }else{
                handleClosePdf();
                descargar(gastos,inicio,fin);
            } 
        }
        handleCloseDescarg();
    }

    const descargar = async (lista,ini,fin) => {
        handleShowDescarg();
        switch (typePdf) {
            case 'semana':
                var date = moment( new Date());
                const fecha = date.tz('America/Mexico_City').format('DD/MM/YYYY')
                const fechaDescarga = moment(fin,'DD/MM/YYYY').format('DD-MM-YYYY')
                //const fecha2 = date.tz('America/Mexico_City').format('DDMMYY')
                //console.log(fecha)
                var doc = new jsPDF({format: 'letter'});
                var company_logo = {
                    w: 30,
                    h: 20
                };

                var startY=0;
                //IMAGEN
                var imgData ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
                doc.addImage(imgData,'JPEG',10,25,company_logo.w,company_logo.h);
                //console.log(doc.internal.pageSize.getHeight())
                var logo = new Image();
                logo.src = watermark;
                doc.addImage(logo, 'JPEG',32.945, 89.7,150,100);
                //TITULO
                doc.addFileToVFS("calibri-bold.ttf", calibriBold);
                doc.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(18);
                doc.setTextColor("#002060")
                doc.text("CONTROL DE GASTOS MANO DE OBRA", doc.internal.pageSize.getWidth() / 2, 15, null, 'center');
                //LINEA #1
                doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                doc.setLineWidth(2.5);    
                doc.line(10, 18, 205, 18); // vertical line    
                //console.log(doc.internal.pageSize.getWidth())
                //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(10);
                doc.setTextColor("black")
                doc.text("OBRA:", 70, 28, null, 'right');
                doc.text("UBICACIÓN:", 70, 33, null, 'right');
                doc.text("CIUDAD:", 70, 38, null, 'right');
                doc.text("ESTADO:", 70, 43, null, 'right');
                doc.text("FECHA:", 150, 45, null, 'right');
                doc.text("SEMANA:", 150, 49, null, 'right');
                //TIPO DE LETRA REGULAR
                doc.addFileToVFS("calibri-regular.ttf", calibriRegular);
                doc.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
                doc.setFont("calibri-regular","normal");
                doc.setFontSize(10);
                doc.text(obra.toUpperCase(), 75, 28, null, 'left');
                doc.text(direccion.toUpperCase(), 75, 33, null, 'left');
                doc.text("CHILPANCINGO", 75, 38, null, 'left');
                doc.text("GUERRERO", 75, 43, null, 'left');
                //FECHA DESCARGA
                doc.setFont("calibri-regular","normal");
                doc.text(fecha, 165, 45, null, 'center');
                //FECHA DEL REPORTE
                doc.setFont("calibri-regular","normal");
                doc.text(ini+" - "+fin, 175, 49, null, 'center');

                //LINEA #2
                doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, 53, 205, 53); // vertical line  
                
                //TABLA
                var rows = lista;
                //console.log(rows)
                const last = rows[rows.length-1];
                const totalSemana=last.totalSemana;
                let datos = []
                rows.forEach((element) => {
                    if(element.extra===0){
                        datos.push([element.nombreEmp+' '+
                        element.apellidoPaternoEmp
                        ,element.dias,"$ "+formato(element.precio),
                        "--------             ",
                        '$ '+formato(element.total)])
                    }else{
                        datos.push([element.nombreEmp+' '+
                        element.apellidoPaternoEmp
                        ,element.dias,"$ "+formato(element.precio),
                        '$ '+element.extra,
                        '$ '+formato(element.total)])
                    }
                });
                //console.log(datos)
                //TABLA
                autoTable(doc,
                    {head: [['NOMBRE', 'DIAS', 'PRECIO','EXTRA','SUBTOTAL']],
                    body:datos , tableWidth: 'wrap',
                    margin: {right:10, left:10 },
                    headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
                    startY: 60,
                    theme:"plain",
                    columnStyles: {
                        0: {halign:"left",cellWidth: 60},
                        1: {halign:"center",cellWidth: 20},
                        2: {halign:"right",cellWidth: 40},
                        3: {halign:"right",cellWidth: 40},
                        4: {halign:"right",cellWidth: 35},
                    }
                })
                startY=doc.lastAutoTable.finalY;
                //LINEA AL FINAL DE LA TABLA
                doc.setDrawColor("black", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, startY, 205, startY); // vertical line  
                //TOTALES
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(12);
                doc.setTextColor("black")
                doc.text("TOTAL", 160, startY+15); 
                doc.text("$ "+formato(totalSemana), 204, startY+15,"right");  

                //var blob = doc.output("blob");
                //window.open(URL.createObjectURL(blob));
                doc.save('GASTOS MO '+obra+' '+fechaDescarga+'.pdf');
            break;
            case 'general':
                var dateGeneral = moment( new Date());
                const fechaGeneral = dateGeneral.tz('America/Mexico_City').format('DD/MM/YYYY')
                let docGeneral = new jsPDF({format: 'letter',orientation:"portrait", title: "Report"});
                var company_logoGeneral = {
                    w: 30,
                    h: 20
                };

                var startYGeneral=0;
                //IMAGEN
                var imgDataGeneral ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
                docGeneral.addImage(imgDataGeneral,'JPEG',10,25,company_logoGeneral.w,company_logoGeneral.h);
                //TITULO
                docGeneral.addFileToVFS("calibri-bold.ttf", calibriBold);
                docGeneral.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(18);
                docGeneral.setTextColor("#002060")
                docGeneral.text("CONTROL GASTOS DE MANO DE OBRA", docGeneral.internal.pageSize.getWidth() / 2, 15, null, 'center');
                //LINEA #1
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(2.5);    
                docGeneral.line(10, 18, 205, 18); // vertical line    
                //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(10);
                docGeneral.setTextColor("black")
                docGeneral.text("OBRA:", 70, 28, null, 'right');
                docGeneral.text("UBICACIÓN:", 70, 33, null, 'right');
                docGeneral.text("CIUDAD:", 70, 38, null, 'right');
                docGeneral.text("ESTADO:", 70, 43, null, 'right');
                docGeneral.text("FECHA:", 150, 45, null, 'right');
                //TIPO DE LETRA REGULAR
                docGeneral.addFileToVFS("calibri-regular.ttf", calibriRegular);
                docGeneral.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
                docGeneral.setFont("calibri-regular","normal");
                docGeneral.setFontSize(10);
                docGeneral.text(obra.toUpperCase(), 75, 28, null, 'left');
                docGeneral.text(direccion.toUpperCase(), 75, 33, null, 'left');
                docGeneral.text("CHILPANCINGO", 75, 38, null, 'left');
                docGeneral.text("GUERRERO", 75, 43, null, 'left');
                //FECHA DESCARGA
                docGeneral.setFont("calibri-regular","normal");
                docGeneral.text(fechaGeneral, 165, 45, null, 'center');
                //LINEA #2
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, 53, 205, 53); // vertical line             
                //TABLA
                var rowsGeneral = lista;
                let datosGeneral = []
                rowsGeneral.forEach((element) => {
                    if(element.extra===0){
                        datosGeneral.push([element.nombreEmp+' '+
                        element.apellidoPaternoEmp
                        ,element.dias,"$ "+formato(element.precio),
                        "--------",moment(element.fecha).format("DD-MM-YYYY"),'$ '+formato(element.total),element.totalSemana? (formato(element.totalSemana)):('')])
                    }else{
                        datosGeneral.push([element.nombreEmp+' '+
                        element.apellidoPaternoEmp
                        ,element.dias,"$ "+formato(element.precio),
                        '$ '+element.extra,moment(element.fecha).format("DD-MM-YYYY"),
                        '$ '+formato(element.total),element.totalSemana? (formato(element.totalSemana)):('')])
                    }
                });
                //console.log(datosGeneral)
                //TABLA  67.58472222222223
                autoTable(docGeneral,
                    {head: [['NOMBRE', 'DIAS', 'PRECIO','EXTRA','FECHA','SUBTOTAL','SEMANA']],
                    body:datosGeneral , tableWidth: 'wrap',
                    margin: {right:10, left:10 },
                    headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
                    startY: 60,
                    theme:"plain",
                    didDrawCell: (data) => {
                        if (data.section === 'body' && data.column.dataKey === 7 && data.cell.raw !== "NaN") {
                        }
                    },
                    columnStyles: {
                        0: {halign:"center",cellWidth: 35},
                        1: {halign:"center",cellWidth: 25},
                        2: {halign:"center",cellWidth: 25},
                        3: {halign:"center",cellWidth: 25},
                        4: {halign:"center",cellWidth: 25},
                        5: {halign:"center",cellWidth: 25},
                        6: {halign:"right",cellWidth: 35},
                        7: {halign:"right",cellWidth: 35}
                    }
                })
                startYGeneral=docGeneral.lastAutoTable.finalY;
                //LINEA AL FINAL DE LA TABLA
                docGeneral.setDrawColor("black", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, startYGeneral, 205, startYGeneral); // vertical line  
                //TOTALES
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(12);
                docGeneral.setTextColor("black")
                docGeneral.text("TOTAL", 160, startYGeneral+15); 
                docGeneral.text("$ "+manoTotal, 204, startYGeneral+15,"right");  
                //FOOTER
                const pageCount = docGeneral.internal.getNumberOfPages();
                for(var i = 1; i <= pageCount; i++) {
                    //MARCA DE AGUA
                    var logoGeneral = new Image();
                    logoGeneral.src = watermark;
                    docGeneral.addImage(logoGeneral, 'JPEG',32.945, 89.7,150,100);
                    docGeneral.setPage(i);
                    docGeneral.text('Página ' + String(i) + ' de ' + String(pageCount),210-20,300-30,null,null,"right");
                }
                //var blobGeneral = docGeneral.output("blob",{filename:"reporte"});
                //window.open(URL.createObjectURL(blobGeneral));
                docGeneral.save('GASTOS MO GENERAL -'+obra+'.pdf');
            break;
            default:
                console.log(`ERROR`);
        }
        handleCloseDescarg();
    }
    /*PDF FIN*/

    return(
        <div className="materiales">
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">CONTROL DE GASTOS DE MANO DE OBRA</label>
                    </div>
                    <div >
                        <div>
                            <label className='text-uppercase'><strong>NOMBRE DE LA OBRA:</strong> {obra}</label>
                        </div>
                        <div>
                            <label className='text-uppercase'><strong>DUEÑO:</strong> {cliente}</label>
                        </div>
                    </div>
                    <div className='divboton' style={{margin:'5px 0'}}>                                                                                             
                        <div className='boton' style={{display:'flex', justifyContent:'space-between'}} >
                            {day !== 7 ? (
                                <button title='REGISTRAR PAGOS' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={handleShowGMO} type="button">
                                    <label className="agregar">REGISTRAR PAGOS</label><BsPlus style={{fontSize:'25px'}}/>
                                </button>
                            ):(
                                <button title='REGISTRAR PAGOS' style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button" disabled>
                                    <label className="agregar">REGISTRAR PAGOS</label><BsPlus style={{fontSize:'25px'}}/>
                                </button>
                            )}
                            <button title='DESCARGAR'  onClick={handleShowPdf} style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button">
                                <BsFiletypePdf style={{fontSize:'25px'}}/> <label className="agregar">DESCARGAR</label>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>
                        </div>
                    </div>
                    <div className='divboton mb-2' style={{textAlign:'right'}}>
                        <div>
                            <strong><h5>{manoTotal === 'NaN' ? ("TOTAL: $"+0):"TOTAL: $"+manoTotal}</h5></strong>
                        </div>
                    </div>
                    { gastos.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                        <div className="caja-asistencia" style={{marginTop:"10px"}} >
                            <div className="table tabla">
                                <table className="table text-uppercase">
                                    <thead >
                                        <tr >
                                            <th>CODIGO</th>
                                            <th>CONCEPTO</th>
                                            <th>DIAS</th>
                                            <th>PRECIO</th>
                                            <th>EXTRA</th>
                                            <th>TOTAL</th>
                                            <th>FECHA</th>
                                            <th>POR SEMANA</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {gastos.map(g =>{
                                            return(
                                                g.totalSemana === 0 ? (
                                                    <tr key={g.idEmpleado + g.fecha}>
                                                    <td>{g.codigoEmp}</td>
                                                    <td>{g.nombreEmp}{' '}{g.apellidoPaternoEmp}{' '}{g.apellidoMaternoEmp}</td>
                                                    <td>{g.dias}</td>
                                                    <td>$ {formato(g.precio)}</td>
                                                    <td>{g.extra===0?'---':'$ '+g.extra}</td>
                                                    <td>$ {formato(g.total)}</td>
                                                    <td>{moment(g.fecha).format("DD-MM-YYYY")}</td>
                                                    <td>{g.totalSemana}</td>
                                                </tr>
                                                ):(
                                                    <tr key={g.idEmpleado + g.fecha} style={{borderBottomColor:'black'}}>
                                                    <td>{g.codigoEmp}</td>
                                                    <td>{g.nombreEmp}{' '}{g.apellidoPaternoEmp}{' '}{g.apellidoMaternoEmp}</td>
                                                    <td>{g.dias}</td>
                                                    <td>$ {formato(g.precio)}</td>
                                                    <td>{g.extra===0?'---':'$ '+g.extra}</td>
                                                    <td>$ {formato(g.total)}</td>
                                                    <td>{moment(g.fecha).format("DD-MM-YYYY")}</td>
                                                    <td>{formato(g.totalSemana)}</td>
                                                </tr>
                                                )
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>           
                        </div>
                    )}

                    {/*PDF*/}
                    <Modal  show={showPdf}  onHide={handleClosePdf} >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>DESCARGAR PDF</Modal.Title>
                            <CloseButton onClick={handleClosePdf} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form >
                            <Modal.Body  style={{textAlign:'left', marginTop:'15px'}}>
                                <div className="mb-3">
                                    <div className="form-check">
                                        <input type="radio" className="form-check-input" onChange={tipoPdf} name="tipoPDF" value="general" id="medium" />
                                        <label className="form-check-label">GENERAL</label>
                                    </div> 
                                </div>
                                <div className="mb-3">
                                    <div className="form-check">
                                        <input type="radio" name="tipoPDF" className="form-check-input" onChange={tipoPdf} value="semana" id="regular" />
                                        <label className="form-check-label">SELECCIONE UNA FECHA</label>
                                    </div> 
                                    {
                                        typePdf==="semana"?(
                                            <div className="mb-3">
                                                <input type="date" className="form-control" onChange={(e)=>setFecha(e.target.value)}  id="exampleFormControlInput1" required/>
                                            </div>
                                        )
                                        :(null)
                                    }
                                </div> 
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClosePdf}>CANCELAR</Button>                                               
                                <Button type="button" className="btn btn-light btncolor" onClick={()=> getRegistros(fechaSelect)} >DESCARGAR</Button>                                                     
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*AGREGAR GASTO ADICIONAL*/}     
                    <Modal  show={showGasMO}  onHide={handleCloseGMO}  fullscreen={true} id="modal-pagos" backdrop="static" keyboard={false}>
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>REGISTRAR PAGOS MANO DE OBRA</Modal.Title>
                            <CloseButton onClick={cancelar} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left',}}>
                            <div className="mb-3" style={{textAlign:'center'}}>
                                <h5 className="modal-title text-uppercase " id="exampleModalLabel">{obra}</h5>
                            </div>
                            <div className="mb-3">
                                <div className="fecha" style={{display:'flex', justifyContent:'space-between'}}>
                                    <input type="date" className="form-control" required value={fechaGMO} onChange={(e)=>setFechaGMO(e.target.value)}  aria-describedby="basic-addon1"/>   
                                    <button type="button" className="btn btncolor" onClick={()=> getGastosAtrasados(fechaGMO)}  >BUSCAR</button>
                                </div>
                            </div>
                            { gastosData.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                                <div className="caja-asistencia" >
                                    <div className="table tabla">
                                        <table className="table  text-uppercase">
                                            <thead >
                                                <tr >
                                                    <th>CODIGO</th>
                                                    <th>CONCEPTO</th>
                                                    <th>DIAS</th>
                                                    <th>PRECIO</th>
                                                    <th>EXTRAS</th>
                                                    <th>CANTIDAD EXTRA</th>
                                                    <th>TOTAL</th>
                                                    <th>CONFIRMAR</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                                {gastosData.map(g =>{
                                                    return(
                                                        <tr key={g.idEmpleado}>
                                                            <td>{g.codigoEmp}</td>
                                                            <td>{g.nombreEmp}{' '}{g.apellidoPaternoEmp}{' '}{g.apellidoMaternoEmp}</td>
                                                            <td>{g.dias}</td>
                                                            <td>$ {g.precio}</td>
                                                            <td>{g.extras===''||g.extras===null||g.extras === 0?'---':g.extras}</td>
                                                            <td>
                                                                {g.extras===null||g.extras === 0 ? (
                                                                    <label>---</label>
                                                                ):(
                                                                    <input type="number"  min={0} id={`ex${g.idEmpleado}`} style={{textAlign:"right"}} />
                                                                )}
                                                            </td>
                                                            <td ><input style={{textAlign:'right'}} id={`t${g.idEmpleado}`} value={`${g.total}`} disabled/></td>
                                                            <td>
                                                                <input className="form-check-input" type="checkbox" id={`cb${g.idEmpleado}`} 
                                                                    onClick={()=> confirmPay(g.idEmpleado,g.codigoEmp, g.nombreEmp, 
                                                                    g.apellidoPaternoEmp, g.apellidoMaternoEmp, g.extras, g.nombrePuesto
                                                                    )}
                                                                    defaultChecked= {lista.some(l => l.idL === g.idEmpleado) === true ? true:false}
                                                                />
                                                            </td>
                                                        </tr>                             
                                                    )
                                                })}                        
                                            </tbody>
                                        </table>
                                    </div>           
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer className="justify-content-center foot">
                            <button type="button" className="btn btn-secondary"  onClick={cancelar}>CANCELAR</button>
                            {lista.length === 0 ? (
                                <button type="button" className="btn btncolor" disabled >ACEPTAR</button>
                            ):(
                                gastosData.length === lista.length ? (
                                    <button type="button" className="btn btncolor" onClick={verificarPagos} >ACEPTAR</button>
                                ):(
                                    <button type="button" className="btn btncolor" onClick={faltaConfirmar} >ACEPTAR</button>
                                )
                            )}                                                  
                        </Modal.Footer>
                    </Modal>

                     {/*CONFIRMAR PAGO*/}     
                     <Modal  show={showCP}  onHide={handleCloseCP} id="modal-confirmar-pagos" backdrop="static" keyboard={false} size="lg">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>VERIFICAR PAGO</Modal.Title>
                            <CloseButton onClick={handleCloseCP} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left', height:'65vh', }}>
                            <div className="mb-6">
                                <strong><label className="form-label">LISTA DE PAGOS</label></strong>
                            </div>
                            <div className="mb-6">
                                <label className="form-label"><strong>NOTA: </strong> SI LOS DATOS ESTAN CORRECTOS OPRIMA CONFIRMAR </label>
                            </div>
                            <div className="mb-6 modal-tabla" >
                                <div className="table-responsive" >
                                    <table className="table  text-uppercase">
                                        <thead >
                                            <tr >
                                                <th>CODIGO</th>
                                                <th>EMPLEADO</th>
                                                <th>DIAS</th>
                                                <th>PAGO</th>
                                                <th>EXTRA</th>
                                                <th>TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {lista.map(l =>{
                                                return(
                                                    <tr key={l.idL}>
                                                        <td>{l.codL}</td>
                                                        <td>{l.nomL}{' '}{l.appL}{' '}{l.apmL}</td>
                                                        <td>{l.diasL}</td>
                                                        <td>{l.preL}</td>
                                                        <td>{l.canExt}</td>
                                                        <td>{l.totL}</td>
                                                    </tr>                   
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>           
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="justify-content-center foot">
                            <button type="button" className="btn btn-secondary"  onClick={handleCloseCP}>CANCELAR</button>
                            { isSaving===true? 
                                <button className="btn btn-primary" type="button" disabled >
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </button>:
                                <button type="button" className="btn btncolor" onClick={guardarPagos} >CONFIRMAR</button>
                            }                                               
                        </Modal.Footer>
                    </Modal>

                    {/*DESCARGANDO....*/}
                    <Modal  show={showDescargar}  onHide={handleCloseDescarg} centered >
                        <Modal.Body  style={{textAlign:'center', marginTop:'15px',marginBottom:"5%"}}>
                            <div>
                                <h3>DESCARGANDO</h3>
                            </div>
                            <div style={{textAlign:'center', marginTop:'15px'}}>
                                <PropagateLoader color="#1A2E4F" />
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default GastosManoObra;